import React, { useState, useEffect, useRef } from 'react';
import Bouton from '../../../../UI/Bouton/Bouton';
import * as type_btn from '../../../../../ressources/glossaires/glossaire_type_de_bouton';
import { GeoIcon } from '../utils/LabelIcons';

const LabelToolbar = ({ loading, onAddLabel, onAddPhase }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handleOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target))
        setMenuOpen(false);
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [menuOpen]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8,
      pointerEvents: 'auto',
    }}>
      {loading && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 6, marginRight: 12,
          color: '#0077b6', fontSize: 12, fontFamily: 'Montserrat, sans-serif',
        }}>
          <span className="leg-spinner" />
          Chargement…
        </div>
      )}
      <div ref={menuRef} style={{ position: 'relative' }}>
        <Bouton
          type={type_btn.succes}
          cliquer={() => setMenuOpen((o) => !o)}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '0 14px', height: '32px',
            borderRadius: '6px', flexShrink: 0,
          }}
          title="Ajouter"
        >
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">
            <line x1="6.5" y1="1" x2="6.5" y2="12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
            <line x1="1" y1="6.5" x2="12" y2="6.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
          </svg>
          <span className="leg-demo-btn-label">Ajouter</span>
        </Bouton>
        {menuOpen && (
          <div className="leg-dropdown-menu">
            <button
              className="leg-dropdown-item"
              onClick={() => { onAddLabel('JALON'); setMenuOpen(false); }}
            >
              <GeoIcon iconType="diamond" size={12} />
              <span>Jalon</span>
            </button>
            <div className="leg-dropdown-divider" />
            <button
              className="leg-dropdown-item"
              onClick={() => { onAddPhase(); setMenuOpen(false); }}
            >
              <span>▬</span>
              <span>Phase</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LabelToolbar;
